import './SettingsOverlay.styles.css'
import {FullscreenButton} from './components/FullscreenButton/FullscreenButton'
import {VolumeButton} from './components/VolumeButton/VolumeButton'

const SettingsOverlay = ({
  settingsRight = false,
  settingsTopRight = false,
  hideFullMode = false,
  isGrillQuizSettings = false,
}: {
  settingsRight?: boolean
  settingsTopRight?: boolean
  hideFullMode?: boolean
  isGrillQuizSettings?: boolean
}) => {
  return (
    <div
      id={settingsRight ? 'settings-right' : settingsTopRight ? 'settings-top-right' : 'settings'}
      style={{zIndex: 999999}}
    >
      <VolumeButton isFlipBurgerSettings={settingsRight} />
      {!hideFullMode && <FullscreenButton isGrillQuizSettings={isGrillQuizSettings} />}
    </div>
  )
}

export default SettingsOverlay
